var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55158 7.97592L7 7.09742L8.44842 7.97592L8.06342 6.328L9.34442 5.229L7.66092 5.07967L7 3.53383L6.33908 5.07967L4.65558 5.229L5.93658 6.328L5.55158 7.97592ZM1.75 11.7116V2.69267C1.75 2.42394 1.84003 2.19975 2.02008 2.02008C2.20014 1.84042 2.42414 1.75039 2.69208 1.75H11.3079C11.5763 1.75 11.8003 1.84003 11.9799 2.02008C12.1596 2.20014 12.2496 2.42433 12.25 2.69267V8.97458C12.25 9.24292 12.16 9.46711 11.9799 9.64717C11.7999 9.82722 11.5759 9.91706 11.3079 9.91667H3.54492L1.75 11.7116ZM3.29583 9.33333H11.3079C11.3974 9.33333 11.4796 9.296 11.5547 9.22133C11.6297 9.14667 11.6671 9.06442 11.6667 8.97458V2.69208C11.6667 2.60264 11.6293 2.52039 11.5547 2.44533C11.48 2.37028 11.3977 2.33294 11.3079 2.33333H2.69208C2.60264 2.33333 2.52039 2.37067 2.44533 2.44533C2.37028 2.52 2.33294 2.60225 2.33333 2.69208V10.2929L3.29583 9.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.f588ebf2e83b265b24122547a5b5c63b.svg";
export { ForwardRef as ReactComponent };